import { render, staticRenderFns } from "./strenzik.vue?vue&type=template&id=21807e5c&scoped=true"
import script from "./strenzik.vue?vue&type=script&lang=js"
export * from "./strenzik.vue?vue&type=script&lang=js"
import style0 from "./strenzik.vue?vue&type=style&index=0&id=21807e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21807e5c",
  null
  
)

export default component.exports